import { useState } from "react";

// import { useInterval } from "usehooks-ts";

export const usePointsReward = (initialValue: number, rate: number) => {
  const [value, _setValue] = useState(initialValue);

  // useInterval(() => {
  //   setValue((prevValue) => prevValue + rate);
  // }, 1000);

  return 86400 * rate + value;
};
